import { FC } from "react";

import { ProviderInformationProps } from "./types";
import { formatPhoneNumber } from "src/helpers";

const ReferringPrescriberAndProviderInformation: FC<ProviderInformationProps> = ({ title, prescriber_information, practice_information }): JSX.Element => {


  return (
    <div className="card">
      <div className="card-header iovera-theme">
        <h4 className="m-0">{title}</h4>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Practice Name:</label>
              </div>
              <div className="col-6">
                <p>
                  {practice_information ? practice_information.name : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Practice NPI:</label>
              </div>
              <div className="col-6">
                <p>
                  {practice_information ? practice_information.npi : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">First:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.first_name : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Speciality:</label>
              </div>
              <div className="col-6">
                <p>
                  {practice_information && practice_information ? practice_information.spaciality : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Last:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.last_name : "N/A"}
                </p>
              </div>
            </div>
          </div>



          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">SOC Type:</label>
              </div>
              <div className="col-6">
                <p>
                  {practice_information ? practice_information.soc : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Prescriber NPI:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.npi : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Prescriber DEA:</label>
              </div>
              <div className="col-6">
                <p>
                  { prescriber_information ? prescriber_information.dea : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Street:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information && prescriber_information ? prescriber_information.street : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Phone Number:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.phone_number ? formatPhoneNumber(prescriber_information.phone_number) : "N/A":'N/A'}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">City:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information && prescriber_information ? prescriber_information.city : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Fax Number:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.fax_number ? formatPhoneNumber(prescriber_information.fax_number) : "N/A":'N/A'}
                </p>
              </div>
            </div>
          </div>


          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">State:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information && prescriber_information ? prescriber_information.state : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6"></div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <label className="form-label">Zip:</label>
              </div>
              <div className="col-6">
                <p>
                  {prescriber_information ? prescriber_information.zip : "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferringPrescriberAndProviderInformation;
